import type { IconSvgObject } from './types';

const FlaticonIcon: IconSvgObject = [
  ["path", { d: "M16 3L13.5 7H6.5L8.5 10H12L10.5 13L14 19L11 21L2 6L5 3H16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M22 6L19 3L13.5 12.5L16 16.5L22 6Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FlaticonIcon;
